
import React from "react";

export default function LoginPage() {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  React.useEffect(() => {
    if (process.env.REACT_APP_AUTH_DISABLED === "true" && isLocal) {
      window.location.href = "/";
    }
  }, [isLocal]);
  const handleLogin = () => {
    window.location.href = "/.auth/login/aad";
  };
  return (
    <div style={{textAlign:'center',marginTop:80}}>
      <h2>请先登录</h2>
      <button onClick={handleLogin} style={{padding:'8px 24px',fontSize:18}}>登录</button>
    </div>
  );
}
